import { useState, useEffect } from 'react';
import './AIReadinessGauge.css';

const AIReadinessGauge = ({ score = 0, tier }) => {
  // SVG Geometry
  const radius = 90;
  const circumference = Math.PI * radius; // ~282.74
  const [offset, setOffset] = useState(circumference);

  useEffect(() => {
    // Trigger transition animation after mount
    const timer = setTimeout(() => {
      const targetOffset = circumference - (circumference * (score / 100));
      setOffset(targetOffset);
    }, 100);
    return () => clearTimeout(timer);
  }, [score, circumference]);

  const getTierLabel = () => {
    const t = tier || (score >= 80 ? 'Advanced' : score >= 50 ? 'Intermediate' : 'Basic');
    if (t.toLowerCase() === 'advanced') return 'High Readiness';
    if (t.toLowerCase() === 'intermediate') return 'Medium Readiness';
    return 'Low Readiness';
  };

  const getTierColorClass = () => {
    const t = tier || (score >= 80 ? 'Advanced' : score >= 50 ? 'Intermediate' : 'Basic');
    if (t.toLowerCase() === 'advanced') return 'tier-high';
    if (t.toLowerCase() === 'intermediate') return 'tier-medium';
    return 'tier-low';
  };

  return (
    <div className="ai-readiness-gauge-card">
      <h4 className="gauge-card-title">AI Readiness Score</h4>
      
      <div className="gauge-container">
        <svg viewBox="0 0 240 130" className="gauge-svg">
          <defs>
            <linearGradient id="gaugeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#7c3aed" />  {/* purple */}
              <stop offset="50%" stopColor="#00e5ff" /> {/* cyan */}
              <stop offset="100%" stopColor="#00e676" /> {/* bright green */}
            </linearGradient>
          </defs>
          {/* Background track */}
          <path
            d="M 30 110 A 90 90 0 0 1 210 110"
            className="gauge-track-bg"
            fill="none"
            strokeWidth="14"
            strokeLinecap="round"
          />
          {/* Animated fill track */}
          <path
            d="M 30 110 A 90 90 0 0 1 210 110"
            className="gauge-track-fill"
            fill="none"
            stroke="url(#gaugeGradient)"
            strokeWidth="14"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        </svg>
        <div className="gauge-score-container">
          <span className="gauge-score-value">{score}</span>
          <span className="gauge-score-total">/100</span>
        </div>
      </div>
      
      <div className={`gauge-tier-label ${getTierColorClass()}`}>
        {getTierLabel()}
      </div>
    </div>
  );
};

export default AIReadinessGauge;
